import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownAZLower } from '../../../../../fontAwesome';

import { SpaceType } from "../../../../../store";

import { LetterSpaceNumberMarkerDecoration } from "./LetterSpaceNumberMarkerDecoration";

export class LowercaseSpaceLetterMarkerDecoration extends LetterSpaceNumberMarkerDecoration {

  textContent(space?: SpaceType): string {
    if (!space) return '__SPACE_LETTER_LOWER__';
    return super.textContent(space).toLowerCase();
  }

  Thumbnail() {
    return (
      <FontAwesomeIcon icon={faArrowDownAZLower} />
    );
  }

  title = 'Lower case Space Letter';
}
